import { render, staticRenderFns } from "./ConnectObject.vue?vue&type=template&id=4bbff408&scoped=true&"
import script from "./ConnectObject.vue?vue&type=script&lang=js&"
export * from "./ConnectObject.vue?vue&type=script&lang=js&"
import style0 from "./ConnectObject.vue?vue&type=style&index=0&id=4bbff408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbff408",
  null
  
)

export default component.exports